import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import 'bootstrap'

import $ from "jquery"

import 'slick-carousel'
import AOS from 'aos'
window.AOS = AOS

window.$ = $;
window.toastr = require('toastr');

import Swiper from 'swiper/bundle';
//import 'swiper/css/bundle';

import './gsap.min.js'
import './TweenMax.min.js'

//import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import './countUp.js'

import './jquery.event.move.js'
import './jquery.twentytwenty.js'

function loadPage() {
    var timelineLoading = new TimelineMax();
    timelineLoading.add([TweenMax.to("#dtx-loader-word-overlay", 3.6, {
        opacity: 0,
        ease: Sine.easeInOut
    }), TweenMax.to("#dtx-loader-background-overlay", 3.6, {
        opacity: 0,
        ease: Sine.easeInOut
    }), TweenMax.to("#dtx-loader-overlay", 1.8, {
        opacity: 0,
        ease: Sine.easeInOut
    })]);
    timelineLoading.add([TweenMax.to("#dtx-loader", 1.8, {
        y: "-100%",
        ease: Sine.easeInOut
    }), TweenMax.to("#dtx-loader-background", 1.8, {
        y: "100%",
        ease: Sine.easeInOut
    }), TweenMax.to("#dtx-page", 1.2, {
        opacity: 1,
        delay: 1.6,
        ease: Sine.easeInOut
    })]);
}

function readmore(){
    if($('.text-readmore').length > 0){		
	    var target = $('.text-readmore');
	    var limit = 350;
	    var textLimited = "";
	    var textLenght = "";

	    target.each(function() {
	        textLenght = $(this).text().length;

	        if (textLenght > limit) {
	            textLimited = $(this).text();
	            $(this).text(textLimited.substr(0, limit) + "...");
	        }
	    });
	}
}
   /*
    var swiper = new Swiper(".front-slider-content", {
        cssMode: true,
        slidesPerView: 3,
        spaceBetween: 30,
        freeMode: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        mousewheel: true,
        keyboard: true,
        breakpoints: {
            // when window width is <= 499px
            100: {
                slidesPerView: 1,
                spaceBetweenSlides: 50
            },
            455: {
                slidesPerView: 2,
                spaceBetweenSlides: 50
            },
            // when window width is <= 999px
            999: {
                slidesPerView: 3,
                spaceBetweenSlides: 50
            }
        },
    });
    */
}

function counters(){
    const counters = document.querySelectorAll('.numbers-list .counter');
    // Main function
    for (let n of counters) {
        const updateCount = () => {
            const target = +n.getAttribute('data-target');
            const count = +n.innerText;
            const speed = 5000; // change animation speed here
            const inc = target / speed;
            if (count < target) {
                n.innerText = Math.ceil(count + inc);
                setTimeout(updateCount, 1);
            } else {
                n.innerText = target;
            }
        }
        updateCount();
    }
}

window.infos = function() {
    document.getElementById("infos").style.display = "block";
    document.getElementById("formation").style.display = "none";
    document.getElementById("experience").style.display = "none";
    document.getElementById("expertise").style.display = "none";

    $('.infos_').addClass('active');
    $('.formation_').removeClass('active');
    $('.experience_').removeClass('active');
    $('.expertise_').removeClass('active');

}

window.formation = function() {
    document.getElementById("infos").style.display = "none";
    document.getElementById("formation").style.display = "block";
    document.getElementById("experience").style.display = "none";
    document.getElementById("expertise").style.display = "none";

    $('.formation_').addClass('active');
    $('.infos_').removeClass('active');
    $('.experience_').removeClass('active');
    $('.expertise_').removeClass('active');

}

window.experience = function() {
    document.getElementById("infos").style.display = "none";
    document.getElementById("formation").style.display = "none";
    document.getElementById("experience").style.display = "block";
    document.getElementById("expertise").style.display = "none";

    $('.experience_').addClass('active');
    $('.formation_').removeClass('active');
    $('.infos_').removeClass('active');
    $('.expertise_').removeClass('active');

}

window.expertise = function() {
    document.getElementById("infos").style.display = "none";
    document.getElementById("formation").style.display = "none";
    document.getElementById("experience").style.display = "none";
    document.getElementById("expertise").style.display = "block";

    $('.expertise_').addClass('active');
    $('.formation_').removeClass('active');
    $('.experience_').removeClass('active');
    $('.infos_').removeClass('active');

}

window.breadcrumb_resize = function(){
    var width_box = $('.breadcrumb').width();
    var height_box = $('.breadcrumb').height();
    var width_only = 0;
    var content = '';
    var qtd_caracter = 0;
    var cont = 0;
    height_box = parseInt(height_box);
    if(height_box > 30){
        var qtd_elen = $('.breadcrumb').find('li').length;
        var width_each = width_box/qtd_elen;
        width_each = parseInt(width_each);

        $('.breadcrumb').find('li').each(function(){
            width_only = $(this).width();
            width_only = parseInt(width_only);
            if(width_only > width_each){
                $(this).width(width_each-6);
                if ($(this).has("a").length > 0){
                    content = $(this).find('a').html();
                    qtd_caracter = width_each/11;
                    qtd_caracter = parseInt(qtd_caracter);
                    content = content.substr(0, qtd_caracter)+'...';
                    $(this).find('a').html(content);
                }else{
                    if(cont > 0){
                        if ($(this).has("span").length > 0){
                            content = $(this).find('span').html();
                            qtd_caracter = width_each/11;
                            qtd_caracter = parseInt(qtd_caracter);
                            content = content.substr(0, qtd_caracter)+'...';
                            $(this).find('span').html(content);
                        }else{
                            content = $(this).html();
                            qtd_caracter = width_each/11;
                            qtd_caracter = parseInt(qtd_caracter);
                            content = content.substr(0, qtd_caracter)+'...';
                            $(this).html(content);
                        }
                    }
                }
            }
            cont = cont+1;
        });
    }
    //console.log(width_each);
}

$(document).ready(function() {
    loadPage();
    readmore();
    counters();
    breadcrumb_resize();

    AOS.init({disable: 'mobile'});
    $('.header-address-home .social-link li').unbind();
	$('.to-top').click(function(){
		$('html, body').animate({ scrollTop: 0 }, 1000);
	});
    if($(window).width() >= 1200){
		$('.section-full-height').css({'min-height':$(window).height()});
	}
    $('.painel-atuacao-pj').mouseover(function(){
		if(!$(':animated').length){
			$('.painel-atuacao-pf').animate({'width':'0%'},500);
			$('.painel-atuacao-pj').animate({'width':'100%'},500);
		}
	}).mouseleave(function(){
		$('.painel-atuacao-pj').animate({'width':'50%'},500);
		$('.painel-atuacao-pf').animate({'width':'50%'},500);
	});
	
	$('.painel-atuacao-pf').mouseover(function(){
		if(!$(':animated').length){
			$('.painel-atuacao-pj').animate({'width':'0%'},500);
			$('.painel-atuacao-pf').animate({'width':'100%'},500);
		}
	}).mouseleave(function(){
		$('.painel-atuacao-pf').animate({'width':'50%'},500);
		$('.painel-atuacao-pj').animate({'width':'50%'},500);
	});

    $('.owl-downloads').owlCarousel({
	    loop: true,
	    margin: 28,
	    responsiveClass: true,
	    nav: true,
	    dots: false,
	    autoplay: true,
	    autoplayHoverPause: true,
	    autoplaySpeed: 1000,
	    autoplayTimeout: 5000,
	    navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
	    responsive: {
	        0:{
	            items: 1
	        },
	        768:{
	            items: 2
	        },
	        992:{
	            items: 3
	        }
	    }
	});
    $('.owl-numeros').owlCarousel({
	    loop: false,
	    margin: 20,
	    responsiveClass: true,
	    nav: true,
	    dots: false,
	    autoplay: false,
	    autoplayHoverPause: true,
	    autoplaySpeed: 1000,
	    autoplayTimeout: 3000,
	    navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
	    responsive: {
	        0:{
	            items: 2
	        },
	        768:{
	            items: 3
	        },
	        992:{
	            items: 4
	        }
	    }
	});
	
	$('.owl-numeros-interno').owlCarousel({
	    loop: false,
	    margin: 20,
	    responsiveClass: true,
	    nav: true,
	    dots: false,
	    autoplay: false,
	    autoplayHoverPause: true,
	    autoplaySpeed: 1000,
	    autoplayTimeout: 3000,
	    navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
	    responsive: {
	        0:{
	            items: 2
	        },
	        768:{
	            items: 3
	        },
	        992:{
	            items: 4
	        },
	        992:{
	            items: 5
	        }
	    }
	});
    /*
    $('div[data-accordion="true"]').each(function(){
		$(this).accordion({
			header: '.header-accordion',
			active: false,
  			collapsible: true
		});
	});
    */

    $('.mt-download').each(function(){
        var thissrc = $(this).attr('src');
        $(this).parent().css('background-image', 'url(' + thissrc + ')');
        $(this).hide();
    });

    $(".twentytwenty-container").twentytwenty();
});

(function(w, d) {
    "use strict";

    const $body = d.querySelector('body');
    const $mobileTrigger = d.querySelector('.header-toggle');
    $mobileTrigger.addEventListener('click', function() {
        $body.classList.toggle('show-mobile-nav');
    });
    $('.header-address-home li').on('click', function() {
        var $flag = $(this).children("a").data("flag");
        $('.header-address-home li>a').each(function() { $(this).removeClass("active") });
        $('.header-address-home address').each(function() { $(this).removeClass("active") });
        $(this).addClass("active");
        $('.header-address-home address.' + $flag).addClass('active')
    });

    const win = $(window);
    win.on('scroll touchstart', function() {
        const scrolled = win.scrollTop();
        // console.log(win.scrollTop());
        if (scrolled > 100) {
            $('body').addClass('show-btn-bottom');
            $('body').addClass('show-scroll');
        } else {
            $('body').removeClass('show-btn-bottom');
            $('body').removeClass('show-scroll');
        }
    });
    var $doc = $('html, body');
    $('[data-js="toogle-top"]').on('click', function() {
        $('body').addClass('show-mobile-nav');

        $doc.animate({
            scrollTop: $('body').offset().top
        }, 500);
        return false;
    })
    $('.up-site-arrow ').on('click', function() {

        $doc.animate({
            scrollTop: $('body').offset().top
        }, 1000);
        return false;
    })



    $('.ico-contact li').each(function() {
        $(this).on('click', function() {

            $('.ico-contact li').each(function() { $(this).children('a').removeClass('active') });

            var $place = $(this).children('a').attr('data-js-for');
            $(this).children('a').addClass('active');
            console.log($place);
            $('.footer-address-group').each(function() { $(this).removeClass('show') })
            $('[data-js="' + $place + '"]').addClass('show')
        })
    });

})(window, document);

$(window).on('load resize',function(){
    breadcrumb_resize();
	$('.box-painel-atuacao').width($(window).width());
	$('.img-sobre').width($(window).width()/2);
});

$(window).on('load scroll',function(){ 
	if($('.count-up').length > 0){
		if(($(window).scrollTop() + $(window).height() - 100) > $('.count-up').offset().top){
			$('.count-up').each(function(){
				var element = $(this);
				if(!(element.hasClass('done'))){
					element.addClass('done');
					var countUp = new CountUp(element.attr('id'), element.data('start'), element.data('end'), null, 5);
					if(!countUp.error){
						countUp.start();
					}else{
						console.error(countUp.error);
					}	
				}
			});
		}
	}
});